import { useRef } from "react";
import { Paperclip, Trash2 } from "lucide-react";
import type { AttachmentRow } from "@cx/contracts";

type Props = {
  items: AttachmentRow[];
  onUpload(file: File): void;
  onDelete(id: string): void;
  canUpload: boolean;
  canDelete: boolean;
  busy?: boolean;
};
const kb = (n: number) =>
  n < 1024 * 1024 ? `${Math.ceil(n / 1024)} KB` : `${(n / 1024 / 1024).toFixed(1).replace(".", ",")} MB`;

export function AttachmentsPanel({ items, onUpload, onDelete, canUpload, canDelete, busy }: Props) {
  const input = useRef<HTMLInputElement>(null);
  return (
    <div>
      {items.length === 0 ? (
        <p className="text-muted">Nenhum anexo.</p>
      ) : (
        <ul className="list-group mb-3">
          {items.map((a) => (
            <li key={a.id} className="list-group-item d-flex align-items-center gap-2">
              <Paperclip size={16} aria-hidden="true" />
              <a href={a.url} className="flex-grow-1 text-truncate">
                {a.fileName}
              </a>
              <span className="text-muted small">{kb(a.sizeBytes)}</span>
              {canDelete && (
                <button
                  type="button"
                  className="btn btn-sm btn-link text-danger"
                  aria-label={`Excluir anexo ${a.fileName}`}
                  onClick={() => onDelete(a.id)}
                >
                  <Trash2 size={16} aria-hidden="true" />
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      {canUpload && (
        <>
          <input
            ref={input}
            type="file"
            hidden
            onChange={(e) => {
              const f = e.target.files?.[0];
              if (f) onUpload(f);
              e.target.value = "";
            }}
          />
          <button
            type="button"
            className="btn btn-outline-primary"
            disabled={busy}
            onClick={() => input.current?.click()}
          >
            {busy ? "Enviando…" : "Adicionar anexo"}
          </button>
          <div className="form-text">PDF, imagens, planilhas e XML até 25 MB.</div>
        </>
      )}
    </div>
  );
}
